@if (!isPreparingModal) {
<efx-modal
    title="Búsqueda avanzada"
    [(show)]="showModal"
    [size]="modalSize.medium"
    (onHide)="didHide()"
>

<!-- Solo mostrar el dropdown si NO hay dominio pre-seleccionado -->
@if (!localStorageService.getPreSelectedDomainForSearch) {
  <efx-dropdown
    label="Seleccionar subdominio"
    id="id"
    labelPosition="top"
    [selectedId]="options[0].id"
    [options]="options"
    bindId="id"
    bindDescription="description"
    [fullWidth]="true"
    [placeholder]="'Seleccione una opción'"
    [isDisabled]="false"
    (onChange)="handleSelectDomain($event)">
  </efx-dropdown>
}

<!-- Mostrar el subdominio seleccionado si hay pre-selección -->
@if (localStorageService.getPreSelectedDomainForSearch) {
  <div class="alert alert-info mb-3">
      <strong>Fuente seleccionada:</strong> {{ domain }} / {{ subDomain }}
  </div>
}

    @if (dataForm.length > 0) {
      <form [formGroup]="form" class="matchkey-form">
        <div class="matchkey-content">
            @for (key of dataForm; track key; let i = $index) {
              <div class="matchkey-row">
                <div class="matchkey-input-col">
                    <label class="efx-label" for="{{key}}">{{key}}</label>
                    <input
                        class="form-control efx-input"
                        type="text"
                        [formControlName]="key"
                        [placeholder]="key"
                        id="{{key}}"
                        (keyup)="onKeyUp($event, i)"
                    />
                    @if (fieldErrors[key]) {
                      <small class="field-error">{{ fieldErrors[key] }}</small>
                    }
                </div>
                <div class="matchkey-hash-col">
                    <div class="hash-toggle-wrap">
                        <input class="efx-checkbox"
                            type="checkbox"
                            id="{{'hash'+key}}"
                            [formControlName]="'hash_'+key"
                        />
                        <label for="{{'hash'+key}}" class="hash-label">
                            <strong>Hash</strong>
                        </label>
                    </div>
                </div>
              </div>
            }

            <div class="matchkey-actions">
                <button type="button" class="efx-button-secondary" (click)="didHide()">Salir</button>
                <button type="button" class="efx-button-primary" (click)="searchForMatchKey()">
                  <span class="material-symbols-outlined">search</span>
                  Buscar
                </button>
            </div>

            <hr>
            <div class="matchkey-warning border-top-1">
                <span class="material-symbols-outlined text-warning">warning</span>
                <p class="m-0">Los valores de la matchkey son Case-Sensitive.</p>
            </div>
        </div>
    </form>
    }
</efx-modal>
}
